import {
  GET_BLACKLISTS,
  GET_BLACKLISTS_FAILED,
  GET_BLACKLISTS_SUCCESS,
} from "../actions/blacklistManagement.action";

const INITIAL_STATE = {
  blacklists: {
    data: {},
    total: 0,
    page: 1,
    search: '',
  },
  error: {},
  loading: false,
};

export default function blacklistReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_BLACKLISTS:
      return Object.assign({}, state, {
        loading: true,
      });
    case GET_BLACKLISTS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        blacklists: {
          ...payload,
          data: payload.data,
        },
      });
    case GET_BLACKLISTS_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
